import { TFilter, TUserTag } from '@centra/centra-ui/dist'
import { TaskFilterConfig } from './models'
import queryString from 'query-string'

export const mapTaskFilter = (filtersConfig: TaskFilterConfig[], userTags: TUserTag[] = []) => {
  const userTagsMap = new Set(userTags)
  const result: TFilter[] = []

  filtersConfig.forEach(c => {
    if (!c.permission) {
      result.push(c.filter)
      return
    }

    if (c.permission?.some(p => userTagsMap.has(p))) {
      result.push(c.filter)
    }
  })

  return result
}

export const getInitialPredicates = (params: queryString.ParsedQuery<string | number>) => {
  const p = Object.keys(params).map(key => {
    if (key === 'createdFrom') {
      return {
        field: key,
        operator: 'GREATER_THAN_EQUALS',
        values: params[key],
      }
    } else if (key === 'createdTo') {
      return {
        field: 'createdFrom',
        operator: 'LESS_THAN_EQUALS',
        values: params[key],
      }
    } else {
      return {
        field: key,
        operator: 'IN',
        values: params[key],
      }
    }
  })

  return p
}
